import { withJwt } from '../../../utils/with-jwt';
import { miEnvironment } from '../mobile-instructions-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { SearchRequest } from '../models/search-request';
import { instructionResponseSchema } from '../schemas/instruction-response.schema';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Searches for instructions based on passed in parameters
 * @param searchRequest The parameters specifying which instructions to search for
 * @returns The searched for instructions
 */
export function postInstructionSearch(
  this: unknown,
  searchRequest: Partial<SearchRequest>
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(miEnvironment.resolve(this).instructionSearchUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(searchRequest),
      })
    )
  ).pipe(selectData(z.array(instructionResponseSchema)));
}
